import { render, staticRenderFns } from "./period-time.vue?vue&type=template&id=6dff1d58"
import script from "./period-time.vue?vue&type=script&lang=js"
export * from "./period-time.vue?vue&type=script&lang=js"
import style0 from "./period-time.vue?vue&type=style&index=0&id=6dff1d58&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports